"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var CrudeTextInputTrash_1 = __importDefault(require("../../../screens/DataEditView/FormComponents/utils/CrudeTextInputTrash"));
var CrudeTextInputComponent_1 = require("./CrudeTextInputComponent");
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var CrudeNumberComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var theme = material_1.useTheme();
    var entity = props.entity;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var variant = ((_a = appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type) || CrudeTextInputComponent_1.defaultSettings.variant;
    var margin = ((_b = appLayout.textfield) === null || _b === void 0 ? void 0 : _b.margin) ? (_c = appLayout.textfield) === null || _c === void 0 ? void 0 : _c.margin : CrudeTextInputComponent_1.defaultSettings.margin;
    var columnName = props.schema.name;
    var columnLabels = (_e = (_d = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _d === void 0 ? void 0 : _d.entity[entity]) === null || _e === void 0 ? void 0 : _e.columns;
    var label = (columnLabels && ((_f = columnLabels[columnName]) === null || _f === void 0 ? void 0 : _f.title)) ? (_g = columnLabels[columnName]) === null || _g === void 0 ? void 0 : _g.title : columnName;
    var description = columnLabels && ((_h = columnLabels[columnName]) === null || _h === void 0 ? void 0 : _h.description);
    var required = !props.schema.nullable;
    var disabled = props.disabled ? props.disabled : false;
    var hideInputArrows = ((_j = appLayout.textfield) === null || _j === void 0 ? void 0 : _j.hideNumberInputArrows) ? (_k = appLayout.textfield) === null || _k === void 0 ? void 0 : _k.hideNumberInputArrows : false;
    var type = CrudeTextInputComponent_1.TextFieldType.number;
    var _l = react_1.default.useState(Number(props.data.data[columnName]) || undefined), value = _l[0], setValue = _l[1];
    react_1.useEffect(function () {
        setValue(Number(props.data.data[columnName]) || undefined);
    }, [props.data]);
    var changeData = function (value) {
        var newData = props.data;
        var newColumnData = newData.data;
        newColumnData[columnName] = value;
        newData.data = newColumnData;
        return newData;
    };
    var onTrashClick = function (event) {
        event.stopPropagation();
        setValue(undefined);
        props.onChange && changeData(undefined) && props.onChange(changeData(undefined));
    };
    return (react_1.default.createElement(material_1.TextField, { name: columnName, InputProps: {
            endAdornment: ((props.clearable || (!required && value && !disabled)) &&
                react_1.default.createElement(CrudeTextInputTrash_1.default, { onTrashClick: function (event) { return onTrashClick(event); } })),
            readOnly: disabled,
            disabled: disabled,
        }, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), InputLabelProps: {
            shrink: true,
            style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center' },
        }, variant: variant, required: required, disabled: disabled, type: type, sx: {
            width: props.fullWidth ? '100%' : '300px',
            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: hideInputArrows ? 'none' : 'block',
            },
            '& input[type=number]': {
                MozAppearance: hideInputArrows ? 'textfield' : '',
            },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2,
            },
        }, margin: margin, autoFocus: false, value: value, onChange: (function (event) {
            var val = Number(event.target.value) || undefined;
            setValue(val);
            props.onChange && changeData(val) && props.onChange(changeData(val));
        }) }));
};
exports.default = CrudeNumberComponent;
